import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import BlueBar from "./blueBar";
import { useTranslation } from "react-i18next";
import IconClosed from "../../assets/iconClosed";
const ModalComponent = ({ isShown, hide, customClass, modalContent, }) => {
    const [isHiding, setIsHiding] = useState(false);
    const [dragOffset, setDragOffset] = useState(0);
    const { t } = useTranslation();
    useEffect(() => {
        if (isShown) {
            const scrollY = window.scrollY;
            document.body.style.top = `-${scrollY}px`;
            document.body.classList.add('noscroll');
            const handlePopState = () => {
                hideModal();
            };
            window.addEventListener("popstate", handlePopState);
            window.history.pushState(null, document.title);
            return () => {
                window.removeEventListener("popstate", handlePopState);
                document.body.classList.remove('noscroll');
                document.body.style.top = '';
                window.scrollTo(0, scrollY);
            };
        }
        else {
            setDragOffset(0);
        }
    }, [isShown]);
    const hideModal = () => {
        setIsHiding(true);
        setTimeout(() => {
            hide();
            setIsHiding(false);
        }, 10);
    };
    const handleTouchStart = (e) => {
        if (window.innerWidth > 996)
            return;
        const touchStartY = e.touches[0].clientY;
        e.currentTarget.dataset.touchStartY = touchStartY.toString();
    };
    const handleTouchMove = (e) => {
        if (window.innerWidth > 996)
            return;
        const touchStartY = parseFloat(e.currentTarget.dataset.touchStartY || "0");
        const touchCurrentY = e.touches[0].clientY;
        const touchDeltaY = touchCurrentY - touchStartY;
        if (touchDeltaY > 0) {
            setDragOffset(touchDeltaY);
        }
        if (touchDeltaY > 300) {
            hideModal();
        }
    };
    const handleTouchEnd = () => {
        setDragOffset(0);
    };
    const opacity = Math.max(1 - dragOffset / 300, 0);
    const modal = (_jsxs(_Fragment, { children: [_jsx("div", { className: "modal__backdrop", onClick: hideModal }), _jsxs("div", { className: `modal__container ${isHiding ? "--hide" : ""} ${customClass ? customClass : ''}`, role: "dialog", style: { bottom: `-${dragOffset}px`, opacity }, children: [_jsx(BlueBar, { onclick: hideModal, customId: "blue-bar-reservation", t: t }), _jsxs("div", { className: `modal__content ${customClass ? customClass : ''}`, children: [_jsx("div", { className: "modal-dragger", onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd }), modalContent, _jsx("div", { className: "modal__footer", children: _jsx("span", { onClick: hideModal, children: _jsx(IconClosed, {}) }) })] })] })] }));
    return isShown ? ReactDOM.createPortal(modal, document.body) : null;
};
export default ModalComponent;
